var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"family-manage"},[_c('div',{staticClass:"tip-cell"},[_vm._v(" 请慎重选择解散家庭组，解散家庭组后不可恢复。 ")]),_c('div',{staticClass:"btn-cell",on:{"click":_vm.disbandFamilyFn}},[_vm._v(" 解散家庭组 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }